import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { InventorySellDownPreviewTable } from '../../../../../../../../../../features/inventory/sell-down/inventory-sell-down-preview-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/sell-down/_sell-down/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsInventory,
      label: 'Sell-Down',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsInventory>,
  head: () => getPageHead('Inventory Sell-Down'),
  component: InventorySellDownList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsInventory}
    />
  );
}

function InventorySellDownList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <InventorySellDownPreviewTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
